import React from "react";
import { useRouter } from "next/router";
import { useStoreState } from "pullstate";

import { applicationRoutes } from "shared/helpers/applicationRouting";
import { UIStore } from "@/store/UIStore";
import PageWrapper from "@/components/PageWrapper";
import PersonalizedArticles from "@/containers/Feed/Articles/PersonalizedArticles";
import PersonalizedPodcasts from "@/containers/Feed/Podcast/PersonalizedPodcasts";

import { FeedQuery } from "./Feed.interface";

const PersonalFeeds: React.FC = () => {
  const router = useRouter();
  const query = router.query?.moje;
  const { userLoggedIn } = useStoreState(UIStore, (store) => store);

  const resolveFeeds = () => {
    switch (query) {
      case FeedQuery.Article:
        return (
          <PageWrapper>
            <PersonalizedArticles />
          </PageWrapper>
        );
      case FeedQuery.Podcast:
        return (
          <PageWrapper>
            <PersonalizedPodcasts />
          </PageWrapper>
        );
      default:
        return router.push(applicationRoutes.FEED);
    }
  };

  if (userLoggedIn) {
    return <>{resolveFeeds()}</>;
  }

  return <></>;
};

export default PersonalFeeds;
